import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-48-harshavardhana-gourineni-guest.webp";
import ThumbImg from "../../assets/images/conversations/048.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: ar-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .ar-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .ar-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .ar-hero { padding-top: 60px; padding-bottom: 60px; }
  .ar-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .ar-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .ar-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ar-hero__title.ar-visible { opacity: 1; transform: translateY(0); }
  .ar-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .ar-hero__spotify.ar-visible { opacity: 1; transform: translateY(0); }
  .ar-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .ar-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .ar-hero__right.ar-visible { opacity: 1; transform: translateY(0); }

  /* thumbnail */
  .ar-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .ar-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .ar-yt-thumb:hover img { opacity: 0.85; }
  .ar-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .ar-yt-thumb__play img { width: 40px; height: 44px; }
  .ar-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .ar-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .ar-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ar-body.ar-visible { opacity: 1; transform: translateY(0); }
  .ar-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .ar-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .ar-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ar-guest.ar-visible { opacity: 1; transform: translateY(0); }
  .ar-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .ar-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .ar-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .ar-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .ar-inner { padding-left: 32px; padding-right: 32px; }
    .ar-hero { padding-top: 32px; padding-bottom: 48px; }
    .ar-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .ar-hero__title { font-size: 24px; }
    .ar-hero__left { gap: 16px; }
    .ar-guest__title { font-size: 24px; margin-bottom: 24px; }
    .ar-guest__photo-bg { width: 260px; height: 300px; }
    .ar-guest__name { font-size: 24px; margin-top: 18px; }
    .ar-body__para { font-size: 14px; margin-bottom: 12px; }
    .ar-body { padding-bottom: 48px; }
    .ar-guest { padding-bottom: 48px; }
    .ar-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .ar-inner { padding-left: 16px; padding-right: 16px; }
    .ar-hero { padding-top: 51px; padding-bottom: 30px; }
    .ar-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .ar-hero__left { gap: 30px; }
    .ar-hero__title { font-size: 30px; }
    .ar-body__para { font-size: 16px; margin-bottom: 10px; }
    .ar-guest__title { font-size: 30px; margin-bottom: 20px; }
    .ar-guest__photo-bg { width: 100%; height: 386px; }
    .ar-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .ar-body { padding-bottom: 30px; }
    .ar-guest { padding-bottom: 30px; }
    .ar-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ar-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "iqNEW6t8EgU";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="ar-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 48 Amara Raja"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="ar-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 48 Amara Raja thumbnail" />
      <div className="ar-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="ar-hero">
      <div className="ar-inner">
        <div className="ar-hero__grid">
          <div className="ar-hero__left">
            <h1 ref={titleRef} className="ar-hero__title">
              EP 48 | What is the future of lead acid batteries? | Amara Raja Energy &amp; Mobility
            </h1>
            <div ref={spotifyRef} className="ar-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/6MmPIgjA3If3ETzxB9dBKe?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 48 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="ar-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="ar-body">
      <div className="ar-inner">
        <p className="ar-body__para">
          Harshavardhana Gourineni is an accomplished business leader who has made significant contributions to the growth and expansion of Amara Raja Energy and Mobility Limited. Harshavardhana has worked in various roles and industries, gaining a wide range of experience and expertise. After living in the US for 25 years, Harsha moved to India and was appointed as Executive Director of Amara Raja. In this role, he is responsible for leading the automotive and industrial business, which has a turnover of over $1 billion in revenue. In this episode, we explore what lies ahead for lead-acid batteries, what could be the relevant use cases for them once replaced with lithium, and how we are going to recycle them sustainably. Check out the episode today!
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="ar-guest">
      <div className="ar-inner">
        <h2 className="ar-guest__title">Our Guest</h2>
        <div>
          <div className="ar-guest__photo-bg">
            <img src={GuestImg} alt="Harshavardhana Gourineni" />
          </div>
          <p className="ar-guest__name">Harshavardhana GOURINENI</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep48AmaraRaja() {
  return (
    <>
      <style>{CSS}</style>
      <div className="ar-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}